var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNowmyplaceIconText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "nowmyplace-icon-text",
    className: "icona-svg",
    "data-name": "nowmyplace icon text",
    xmlns: "http://www.w3.org/2000/svg",
    width: 188.922,
    height: 24.238,
    viewBox: "0 0 188.922 24.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_219",
    "data-name": "Raggruppa 219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_206",
    "data-name": "Tracciato 206",
    d: "M249.951,202.335V189.343a.564.564,0,0,1,.638-.638h2.35a.564.564,0,0,1,.638.638v22.593a.564.564,0,0,1-.638.638h-.3a.811.811,0,0,1-.772-.436L243.4,198.575h-.067v12.991a.564.564,0,0,1-.638.638h-2.35a.564.564,0,0,1-.638-.638V188.974a.564.564,0,0,1,.638-.638h.3a.812.812,0,0,1,.772.437l8.46,13.562Z",
    transform: "translate(-239.712 -188.336)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_220",
    "data-name": "Raggruppa 220",
    transform: "translate(16.53 0.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_207",
    "data-name": "Tracciato 207",
    d: "M292.846,188.415a12.086,12.086,0,1,1-12.053,12.12A12.064,12.064,0,0,1,292.846,188.415Zm0,20.815a8.729,8.729,0,1,0-8.7-8.7A8.725,8.725,0,0,0,292.846,209.23Z",
    transform: "translate(-280.793 -188.415)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_221",
    "data-name": "Raggruppa 221",
    transform: "translate(41.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_208",
    "data-name": "Tracciato 208",
    d: "M358.309,201.328l1.88-12.051a.636.636,0,0,1,.7-.571h2.551q.671,0,.571.705L359.786,212a.618.618,0,0,1-.672.571h-.2a.675.675,0,0,1-.739-.538l-4.4-14.233h-.067l-4.4,14.233a.675.675,0,0,1-.738.538h-.2A.618.618,0,0,1,347.7,212l-4.23-22.593q-.1-.706.571-.705h2.518a.636.636,0,0,1,.7.571l1.88,12.051h.067l3.692-12.454a.675.675,0,0,1,.739-.538h.2a.675.675,0,0,1,.739.538l3.659,12.454Z",
    transform: "translate(-343.458 -188.336)",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_222",
    "data-name": "Raggruppa 222",
    transform: "translate(69.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_209",
    "data-name": "Tracciato 209",
    d: "M432.679,212.2h-2.35a.584.584,0,0,1-.672-.6l-1.242-11.313h-.067l-4.062,11.783a.68.68,0,0,1-.705.5h-.3a.647.647,0,0,1-.7-.5l-4.062-11.783h-.067L417.2,211.6a.606.606,0,0,1-.671.6h-2.35q-.672,0-.571-.672l2.854-22.593a.606.606,0,0,1,.672-.6h.235a.649.649,0,0,1,.7.5l5.337,15.509h.067l5.3-15.509a.679.679,0,0,1,.7-.5h.235a.585.585,0,0,1,.671.6l2.854,22.593Q433.351,212.2,432.679,212.2Z",
    transform: "translate(-413.599 -188.336)",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_223",
    "data-name": "Raggruppa 223",
    transform: "translate(90.054 0.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_210",
    "data-name": "Tracciato 210",
    d: "M473.819,189.254h2.652q.738,0,.5.738l-4.9,12.085v10.037a.564.564,0,0,1-.638.638h-2.35a.564.564,0,0,1-.638-.638V202.078l-4.867-12.085q-.235-.738.5-.738H466.7a.671.671,0,0,1,.738.5l2.786,7.62h.067l2.786-7.62A.67.67,0,0,1,473.819,189.254Z",
    transform: "translate(-463.524 -189.254)",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_224",
    "data-name": "Raggruppa 224",
    transform: "translate(111.813 0.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_211",
    "data-name": "Tracciato 211",
    d: "M520.59,212.753h-2.35a.564.564,0,0,1-.638-.638V189.892a.564.564,0,0,1,.638-.638h5.338a5.76,5.76,0,0,1,4.481,1.914,7.576,7.576,0,0,1,1.729,5.271,7.427,7.427,0,0,1-1.746,5.2,5.773,5.773,0,0,1-4.465,1.914h-2.35v8.56A.564.564,0,0,1,520.59,212.753Zm.638-12.622h1.611q3.222,0,3.223-3.692,0-3.759-3.223-3.76h-1.611Z",
    transform: "translate(-517.602 -189.254)",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_225",
    "data-name": "Raggruppa 225",
    transform: "translate(127.086 0.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_212",
    "data-name": "Tracciato 212",
    d: "M564.526,212.753H556.2a.564.564,0,0,1-.638-.638V189.892a.564.564,0,0,1,.638-.638h2.35a.564.564,0,0,1,.638.638v19.437h5.338a.564.564,0,0,1,.638.638v2.148A.564.564,0,0,1,564.526,212.753Z",
    transform: "translate(-555.563 -189.254)",
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_226",
    "data-name": "Raggruppa 226",
    transform: "translate(139.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_213",
    "data-name": "Tracciato 213",
    d: "M600.1,212.2H597.62a.674.674,0,0,1-.738-.537l-.906-3.29h-5.908l-.906,3.29a.675.675,0,0,1-.739.537H585.9q-.739,0-.537-.7l6.848-22.626a.675.675,0,0,1,.738-.538h.1a.675.675,0,0,1,.738.538l6.848,22.626Q600.842,212.2,600.1,212.2Zm-9.064-7.251H595L593.054,198h-.067Z",
    transform: "translate(-585.324 -188.336)",
    fill: "#fff"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_227",
    "data-name": "Raggruppa 227",
    transform: "translate(154.646 0.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_214",
    "data-name": "Tracciato 214",
    d: "M636.18,188.415a11.654,11.654,0,0,1,8.124,3.122.624.624,0,0,1,.033.94l-1.477,1.51c-.235.3-.537.3-.839,0a9.1,9.1,0,0,0-5.808-2.249,8.716,8.716,0,0,0,.034,17.424,8.992,8.992,0,0,0,5.774-2.215.614.614,0,0,1,.806-.034l1.545,1.51a.64.64,0,0,1-.034.907,11.522,11.522,0,0,1-8.158,3.256,12.086,12.086,0,1,1,0-24.172Z",
    transform: "translate(-624.06 -188.415)",
    fill: "#fff"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_228",
    "data-name": "Raggruppa 228",
    transform: "translate(178.381 0.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_215",
    "data-name": "Tracciato 215",
    d: "M692.949,212.753h-9.265a.564.564,0,0,1-.638-.638V189.892a.564.564,0,0,1,.638-.638h9.265a.564.564,0,0,1,.638.638v2.149a.564.564,0,0,1-.638.638h-6.277v6.378h5.1a.564.564,0,0,1,.638.638v2.148a.564.564,0,0,1-.638.638h-5.1v6.849h6.277a.564.564,0,0,1,.638.638v2.148A.564.564,0,0,1,692.949,212.753Z",
    transform: "translate(-683.046 -189.254)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNowmyplaceIconText);
export default __webpack_public_path__ + "static/media/nowmyplace-icon-text.977d432806531e6345ef94eed67cb6df.svg";
export { ForwardRef as ReactComponent };